import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IAutomobileApplication } from "../../automobileApplication/automobileApplication.types";
import { IAutomobileAlbertaApplication } from "../../automobileAlbertaApplication/automobileAlbertaApplication.types";
import { endPoints } from "../../../constants/endPoints";

export const FETCH_LEAD_AUTO_APPLICATION_PROGRESS =
  "FETCH_LEAD_AUTO_APPLICATION_PROGRESS";
export const FETCH_LEAD_AUTO_APPLICATION_SUCCESS =
  "FETCH_LEAD_AUTO_APPLICATION_SUCCESS";
export const FETCH_LEAD_AUTO_APPLICATION_FAILED =
  "FETCH_LEAD_AUTO_APPLICATION_FAILED";

export const fetchLeadAutoApplicationProgress = () =>
  action(FETCH_LEAD_AUTO_APPLICATION_PROGRESS);
export const fetchLeadAutoApplicationSuccess = (
  data: IAutomobileApplication | IAutomobileAlbertaApplication,
  subType: "ab" | "on"
) => action(FETCH_LEAD_AUTO_APPLICATION_SUCCESS, { data, subType });
export const fetchLeadAutoApplicationFailed = () =>
  action(FETCH_LEAD_AUTO_APPLICATION_FAILED);

export const CLEAR_LEAD_AUTO_APPLICATION_STATE =
  "CLEAR_LEAD_AUTO_APPLICATION_STATE";
export const clearLeadAutoApplicationState = () =>
  action(CLEAR_LEAD_AUTO_APPLICATION_STATE);

export const fetchLeadAutoApplication =
  (
    leadId: string,
    incrementalNumber: number,
    subType?: string | null
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadAutoApplicationProgress());
      const resolvedSubType: "ab" | "on" =
        subType === "ab" ? "ab" : "on";
      let url = `${endPoints.leadApplications.getAutoApplication}?lead_id=${leadId}&incremental_number=${incrementalNumber}`;
      if (subType) {
        url += `&sub_type=${encodeURIComponent(subType)}`;
      }
      const res = await api.get(url);
      const data: (IAutomobileApplication | IAutomobileAlbertaApplication)[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLeadAutoApplicationSuccess(data[0], resolvedSubType));
      } else {
        const fallbackData =
          resolvedSubType === "ab"
            ? getState().leadAutoApplication.data_ab
            : getState().leadAutoApplication.data_on;
        dispatch(fetchLeadAutoApplicationSuccess(fallbackData, resolvedSubType));
      }
    } catch (err: any) {
      dispatch(fetchLeadAutoApplicationFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const upsertLeadAutoApplication =
  (
    data: IAutomobileApplication | IAutomobileAlbertaApplication,
    leadId: string,
    onCallback: (isSuccess: boolean, incrementalNumber?: number | null) => void,
    subType: "ab" | "on" = "on"
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const { customer_id, customer_policy_id, ...rest } = data as any;
      const res = await api.post(endPoints.leadApplications.upsertAutoApplication, {
        ...rest,
        lead_id: leadId,
        incremental_number: data.incremental_number,
      });
      const returnedIncrementalNumber =
        res.data.data?.incremental_number ?? null;
      onCallback(true, returnedIncrementalNumber);
      dispatch(
        showMessage({
          type: "success",
          message: "Application saved successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchLeadAutoApplicationSuccess(data, subType));
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };
